import axios from "axios";
import { getUsertoken } from "@/utils/auth";

function getAuthHeaders() {
  const token = getUsertoken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export default {
  namespaced: true,
  state: () => ({
    tipos: [],
    seleccionado: null,
  }),
  getters: {
    tipoSeleccionado: (state) => state.seleccionado,
    todosLosTipos: (state) => state.tipos,
    tipoSeleccionadoSlug: (state) => {
      const tipo = state.tipos.find(t => t.nombre === state.seleccionado);
      return tipo?.slug || null;
    },
  },
  mutations: {
    SET_TIPOS(state, tipos) {
      state.tipos = tipos;
    },
    SET_SELECCIONADO(state, tipo) {
      state.seleccionado = tipo;
    },
  },
  actions: {
    async fetchTipos({ commit, state }) {
      try {
        const respuesta = await axios.get(
          process.env.VUE_APP_BASE_URL + "carniceria/piezas",
          { headers: getAuthHeaders() }
        );

        if (respuesta.data && respuesta.data.length > 0) {
          const tipos = respuesta.data.map(item => ({
            id: item.id,
            nombre: item.nombre,
            slug: item.slug,
            descripcion: item.descripcion || "",
            kilos_a_restar: item.kilos_a_restar ?? null
          }));
          commit("SET_TIPOS", tipos);

          if (!state.seleccionado) {
            commit("SET_SELECCIONADO", tipos[0].nombre);
          }
          return;
        }
      } catch (error) {
        console.error("Error al obtener tipos del backend:", error);
      }

      commit("SET_TIPOS", []);
      commit("SET_SELECCIONADO", null);
    },
    async crearTipo({ dispatch }, { nombre, descripcion, kilos_a_restar }) {
      try {
        const respuesta = await axios.post(
          process.env.VUE_APP_BASE_URL + "carniceria/piezas",
          { nombre, descripcion, kilos_a_restar },
          { headers: { ...getAuthHeaders(), "Content-Type": "application/json" } }
        );

        if (respuesta.data) {
          await dispatch('fetchTipos');
          return { success: true, data: respuesta.data };
        }
      } catch (error) {
        console.error("Error al crear tipo:", error);
        return { success: false, error };
      }
    },
    async actualizarTipo({ dispatch }, { id, nombre, descripcion, kilos_a_restar }) {
      try {
        const respuesta = await axios.put(
          process.env.VUE_APP_BASE_URL + `carniceria/piezas/${id}`,
          { nombre, descripcion, kilos_a_restar },
          { headers: { ...getAuthHeaders(), "Content-Type": "application/json" } }
        );

        if (respuesta.data) {
          await dispatch('fetchTipos');
          return { success: true, data: respuesta.data };
        }
      } catch (error) {
        console.error("Error al actualizar tipo:", error);
        return { success: false, error };
      }
    },
    async eliminarTipo({ dispatch }, id) {
      try {
        const respuesta = await axios.delete(
          process.env.VUE_APP_BASE_URL + `carniceria/piezas/${id}`,
          { headers: getAuthHeaders() }
        );

        if (respuesta.data) {
          await dispatch('fetchTipos');
          return { success: true, data: respuesta.data };
        }
      } catch (error) {
        console.error("Error al eliminar tipo:", error);
        return { success: false, error };
      }
    },
    seleccionarTipo({ commit }, tipo) {
      commit("SET_SELECCIONADO", tipo);
    },
  },
};